import {GoalsController} from '@api/goals-api/goals-controller';
import {GoalsRequestImpl} from '@api/goals-api/goals-request';
import {useStoreContext} from '@store/store-context';
import {ConfirmationDialog} from '@ui/molecules/confirmation-dialog';
import React from 'react';

export const ArchiveGoal: React.FC<{handleContinue: () => void}> = () => {
  const {goalsState} = useStoreContext();
  const closeModal = () => goalsState.setArchiveModal('', false, '', '');

  const handleArchive = () => {
    const request = new GoalsRequestImpl();
    const controller = new GoalsController(request);
    controller.archiveGoal({}, goalsState.archiveId);
    closeModal();
  };

  return (
    <ConfirmationDialog
      open
      title={`Archive ${goalsState.goalFramework}?`}
      confirmLabel={`Archive ${goalsState.goalFramework}`}
      onCancel={closeModal}
      onConfirm={handleArchive}>
      Archiving <strong>{goalsState.archiveName}</strong> will remove it from
      active views. You can restore it later.
    </ConfirmationDialog>
  );
};
